import launchPadLayout from "./layoutReducer";
import domains from "./domainReducer";
import skillPaths from "./skillPathReducer";
import courses from "./courseReducer";
import skillPathLevels from "./skillPathLevelsReducer";
import dataRefresh from "./dataReducer";
import userConfiguration from "./userConfigurationReducer";
import profile from "./profileReducer";
import skillPathPage from "./skillPathPageReducer";

const reducers = {
  launchPadLayout,
  domains,
  skillPaths,
  courses,
  skillPathLevels,
  dataRefresh,
  userConfiguration,
  profile,
  skillPathPage,
};

export default reducers;
